import { Component, OnInit, forwardRef, Optional, Inject, Injector, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';

import { ElementBase, OptionValue, SelectOption } from '../../../common';

@Component({
    selector: 'aa-radio-group',
    templateUrl: './radio-group.component.html',
    styleUrls: [
        './radio-group.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadioGroupComponent),
            multi: true
        }
    ],
    standalone: false
})
export class RadioGroupComponent extends ElementBase<OptionValue> implements OnInit
{
    @Input() name: string;
    @Input() options: SelectOption[];
    @Input() orientation: string = 'horizontal';
    @Input() toTranslate: boolean = false;
    @Input() lineSize: number = 0;
    @Input() marginTop: number = 20;
    public lines: number[];

    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        injector: Injector
    )
    {
        super(injector);
    }

    ngOnInit ()
    {
        if (this.lineSize !== 0)
        {
            const nbLines = Math.ceil(this.options.length / this.lineSize);

            this.lines = Array.from(Array(nbLines));
        }
    }

    toggle (v: OptionValue)
    {
        this.value = v;
    }
}
